import React from 'react';
import { thumbnailOverlayPropTypes, thumbnailOverlayDefaultProps } from '../propTypes';
import { THUMBNAIL_OVERLAY_COLOR } from '../constants';
/**
 * ThumbnailOverlay renders an icon centered in a semi-transparent background overlay.
 *
 * @param {Object} props
 * @param {React.ElementType} props.icon - The icon component to render.
 * @param {Object} [props.iconProps] - Additional props to pass to the icon.
 * @param {string} [props.className] - Additional class names for the wrapper.
 * @param {Object} [props.style] - Additional styles for the wrapper.
 * @returns {JSX.Element}
 */
const ThumbnailOverlay = ({
  icon: Icon,
  iconProps,
  className,
  style,
}) => (
  <span
    className={
      `sui-absolute sui-inset-0 sui-flex sui-items-center sui-justify-center sui-text-inverse ${
        className || ''
      }`
    }
    style={{
      backgroundColor: THUMBNAIL_OVERLAY_COLOR,
      ...style,
    }}
  >
    <Icon color="current" {...iconProps} />
  </span>
);

ThumbnailOverlay.propTypes = thumbnailOverlayPropTypes;
ThumbnailOverlay.defaultProps = thumbnailOverlayDefaultProps;

export default ThumbnailOverlay;